import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from "../views/HomeView.vue";
// import Registration from "../views/Registration.vue";
// import ConfirmAge from "../views/ConfirmAge.vue";
// import RegisterForEvent from "../views/RegisterForEvent.vue";
// import SocialLead from "../views/SocialLead.vue";
import FortuneSpin from "../views/FortuneSpin.vue";
import ParkLive from "../views/ParkLive.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   component: HomeView,
  // },
  // {
  //   path: "/registration",
  //   name: "registration",
  //   component: Registration,
  // },
  // {
  //   path: "/",
  //   name: "confirm-age",
  //   component: ConfirmAge,
  // },
  // {
  //   path: "/register-for-event",
  //   name: "RegisterForEvent",
  //   component: RegisterForEvent,
  // },
  //  {
  //   path: "/absolut",
  //   name: "SocialLead",
  //   component: SocialLead,
  // },
  // {
  //   path: "/parklive",
  //   name: "ParkLive",
  //   component: ParkLive,
  // },
  // {
  //   path: "/park-live",
  //   name: "ParkLiveAlt",
  //   component: ParkLive,
  // },
  {
    path: "/absolut-tabasco",
    name: "AbsolutTabasco",
    component: ParkLive,
  },
  {
    path: "/promo",
    name: "FortuneSpin",
    component: FortuneSpin,
  },
  {
    path: "/unsubscribe/:leadId",
    name: "Unsubscribe",
    component: () => import("@/views/UnsubscribeView.vue"),
  },
  {
    path: "/unsubcribe/:leadId",
    redirect: "/unsubscribe/:leadId",
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});
// Глобальный guard для проверки возраста
router.beforeEach((to, from, next) => {
    // const userAge = JSON.parse(localStorage.getItem('userAge'));

    // если идём на главную и возраст есть → сразу на /chivas
    // if (to.path === "/") {
    //   if (userAge) {
    //     return next("/jameson");
    //   }
    //   return next(); // иначе остаёмся на главной
    // }

    // // если идём на /chivas, но возраста нет → возвращаем на /
    // if (to.path === "/jameson" && !userAge) {
    //   return next("/");
    // }

    next();
});



export default router;
